import React from 'react';
import ReactDOM from 'react-dom/client';
import {initEffects} from '@ngneat/effects';
import {enableElfProdMode} from '@ngneat/elf';

import App from './App';
import '@utils/i18n.utils';
import reportWebVitals from './reportWebVitals';

initEffects();

if (process.env.NODE_ENV !== 'development') {
  enableElfProdMode();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
